import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  if (response?.status === 'SUCCESS' && response?.data?.status === 'SUCCESS') {
    return isSuccessResponse(response)
  } else {
    throw {
      message: 'An Unexpected error has occoured',
    }
  }
}

const getDeviceVariantListApi = (type: String, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getDeviceVariantListApi),
    method: 'POST',
    config: sitConfig(tokens),
    body: getDeviceVariantListRequest(type),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export const getDeviceVariantListRequest = (type: String) => ({ type })

export { getDeviceVariantListApi }
